import { render, staticRenderFns } from "./benefit.vue?vue&type=template&id=06af4ff4&scoped=true&"
import script from "./benefit.vue?vue&type=script&lang=js&"
export * from "./benefit.vue?vue&type=script&lang=js&"
import style0 from "./benefit.vue?vue&type=style&index=0&id=06af4ff4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06af4ff4",
  null
  
)

export default component.exports